<template>
  <div class="molecule-file-upload">
    <h3 class="molecule-file-upload__title">{{ title }}</h3>
    <AtomFileInput :accept="accept" :placeholder="placeholder" :selected-file="selectedFile" :disabled="disabled" @file-selected="handleFileSelected" />
  </div>
</template>

<script>
  import AtomFileInput from "../atoms/AtomFileInput.vue";

  export default {
    name: "MoleculeFileUpload",
    components: {
      AtomFileInput,
    },
    props: {
      title: {
        type: String,
        default: "Soportes",
      },
      placeholder: {
        type: String,
        default: "Selecciona un archivo",
      },
      accept: {
        type: String,
        default: "image/*,.pdf,.doc,.docx,.xml,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      },
      selectedFile: {
        type: File,
        default: null,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
    },
    emits: ["file-selected"],
    methods: {
      handleFileSelected(file) {
        this.$emit("file-selected", file);
      },
    },
  };
</script>

<style lang="scss" scoped>
  .molecule-file-upload {
    &__title {
      margin: 0 0 12px 0;
      font-size: 16px;
      font-weight: 500;
      font-family: $newFont_medium;
      text-transform: capitalize;
      color: #3d3d3d;
    }
  }
</style>
